<template>
  <div class="Site PageBox">
    <van-nav-bar
      fixed
      :border="false"
      :title="$t('language')"
      left-arrow
      @click-left="$router.go(-1)"
    />
    <div class="ScrollBox">
      <van-cell v-for="(item,index) in $langList" :icon="`./static/icon/${item.lang}.png`" :title="item.title" is-link @click="changeLanguage(item.lang)" :key="index" />
    </div>
  </div>
</template>
<script>
export default {
  name: 'Language',
  components: {

  },
  props: {},
  data() {
    return {

    }
  },
  computed: {

  },
  watch: {

  },
  created() {
    
  },
  mounted() {
    
  },
  activated() {

  },
  destroyed() {
    
  },
  methods: {
    changeLanguage(lan) {
      this.$SetLanguage(lan)
      localStorage.removeItem('InitData');
      this.$store.dispatch('UpdateInitData', {
        noticelist: [],
        serviceList: [],
        popupActivity: []
      });
      this.$Model.GetBackData()
      this.$router.go(-1)
    },
  }
}
</script>
<style scoped>
.van-cell__left-icon{
  height: auto;
  line-height: 1;
}
</style>